import { render, staticRenderFns } from "./k-edit-table.vue?vue&type=template&id=4f358721&scoped=true&"
import script from "./k-edit-table.vue?vue&type=script&lang=ts&"
export * from "./k-edit-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f358721",
  null
  
)

export default component.exports